import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App } from "./App.js";
import "./tokens.css";

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root");

// Availability is recomputed rather than held, so cached slot data is treated
// as short-lived everywhere in the app (see the stale banner, 2v).
const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 60_000, retry: 1 } },
});

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
